/* =============================================================
   Home Page — United Dream Mongolia
   Flow: Header → Hero (4 CTAs) → About → Footer
   ============================================================= */
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <AboutSection />
      <Footer />
    </div>
  );
}
